import { useState, useEffect } from "react";
import type { Particle } from "@/types";

interface ConfettiProps {
    show: boolean;
}

export function Confetti({ show }: ConfettiProps) {
    const [particles, setParticles] = useState<Particle[]>([]);

    useEffect(() => {
        if (show) {
            const colors = [
                "#ff6b6b",
                "#4ecdc4",
                "#ffe66d",
                "#95e1d3",
                "#f38181",
                "#aa96da",
                "#fcbad3",
            ];
            const newParticles: Particle[] = [];
            for (let i = 0; i < 50; i++) {
                newParticles.push({
                    id: i,
                    x: Math.random() * 100,
                    color: colors[Math.floor(Math.random() * colors.length)],
                    delay: Math.random() * 0.5,
                });
            }
            setParticles(newParticles);

            const timer = setTimeout(() => {
                setParticles([]);
            }, 3000);

            return () => clearTimeout(timer);
        }
    }, [show]);

    if (particles.length === 0) return null;

    return (
        <div className="fixed inset-0 pointer-events-none z-50 overflow-hidden">
            {particles.map((particle) => (
                <div
                    key={particle.id}
                    className="absolute w-3 h-3 rounded-sm confetti-particle"
                    style={{
                        left: `${particle.x}%`,
                        bottom: "-20px",
                        backgroundColor: particle.color,
                        animationDelay: `${particle.delay}s`,
                    }}
                />
            ))}
        </div>
    );
}
